






import { Component, Vue } from 'vue-property-decorator';
import AdminIframe from '@/components/iframe/AdminIframe.vue';

@Component({
  components: { AdminIframe },
})
export default class DisplayPriorityIframe extends Vue {
  private remoteSrc = '';

  private setRemoteSrc() {
    const query = this.$route.query;
    const queryObject = { ...query, serviceType: 'PREMIUM' };
    const queryString = new URLSearchParams(queryObject).toString();
    this.remoteSrc =
      process.env.VUE_APP_ADMIN_REMOTE_URL + '/display/display-category-priority?' + queryString;
  }

  created() {
    this.setRemoteSrc();
  }
}
